/* tslint:disable */
/* eslint-disable */
/**
 * MachineGo P1 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RenterCompanyAgreementsViewModel
 */
export interface RenterCompanyAgreementsViewModel {
    /**
     * 
     * @type {string}
     * @memberof RenterCompanyAgreementsViewModel
     */
    agreementVersion?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RenterCompanyAgreementsViewModel
     */
    kvkkVersion?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RenterCompanyAgreementsViewModel
     */
    ipazVersion?: string | null;
}

export function RenterCompanyAgreementsViewModelFromJSON(json: any): RenterCompanyAgreementsViewModel {
    return RenterCompanyAgreementsViewModelFromJSONTyped(json, false);
}

export function RenterCompanyAgreementsViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): RenterCompanyAgreementsViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'agreementVersion': !exists(json, 'agreementVersion') ? undefined : json['agreementVersion'],
        'kvkkVersion': !exists(json, 'kvkkVersion') ? undefined : json['kvkkVersion'],
        'ipazVersion': !exists(json, 'ipazVersion') ? undefined : json['ipazVersion'],
    };
}

export function RenterCompanyAgreementsViewModelToJSON(value?: RenterCompanyAgreementsViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'agreementVersion': value.agreementVersion,
        'kvkkVersion': value.kvkkVersion,
        'ipazVersion': value.ipazVersion,
    };
}

